import { render } from "./HeroAuthGrid.vue?vue&type=template&id=6202774a&scoped=true"
import script from "./HeroAuthGrid.vue?vue&type=script&lang=js"
export * from "./HeroAuthGrid.vue?vue&type=script&lang=js"

import "./HeroAuthGrid.vue?vue&type=style&index=0&id=6202774a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6202774a"]])

export default __exports__